import styles from "./Help.module.css";
import helpIcon from "../../../assets/icons/help.png";
import exitIcon from "../../../assets/icons/exit.svg";
import ToggleButton from "../../UI/ToggleButton";
import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import React from "react";
import ButtonAdditionalQuestions from "../2_ServiceSelection/ButtonAdditionalQuestions";
import TypeFilter from "../2_ServiceSelection/TypeFilter";

const Help = React.forwardRef(
    (
        {
            onClose,
            description,
            title,
            inHelp,
            setInHelp,
            setSubmit,
            setSelectedAttributes,
            goToFinalForm,
            selectedAttributes,
            serviceTypes,
            setServiceTypes,
        },
        ref
    ) => {
        const timeoutRef = useRef(null);

        useEffect(() => {
            if (inHelp.questions && inHelp.questions.length > 0) {
                setInHelp((prevVal) => ({
                    ...prevVal,
                    questions: JSON.parse(JSON.stringify(selectedAttributes)),
                }));
            }
        }, [selectedAttributes]);

        useEffect(() => {
            if (inHelp.questions.length > 0) {
                setSubmit({
                    function: () => {
                        setSelectedAttributes(inHelp.questions);
                        onClose();
                        goToFinalForm();
                    },
                    value: "Potvrdi",
                });
            }
        }, [inHelp.questions, inHelp]);

        useEffect(() => {
            if (inHelp.quickTip && inHelp.quickTip === true) {
                setTimeout(() => {
                    setInHelp((prevValue) => ({
                        ...prevValue,
                        active: true,
                        quickTip: false,
                    }));
                }, 500);
            }
        }, [inHelp.quickTip]);

        const toggleSelectedAttribute = (e) => {
            const id = e.target.value;

            const tempArray = { ...inHelp };

            tempArray.questions[id].active = !tempArray.questions[id].active;

            setInHelp(tempArray);
        };

        return (
            <>
                <div
                    ref={ref}
                    className={`${styles.container} ${
                        inHelp.questions.length > 0 &&
                        styles[`container-questions`]
                    } ${!inHelp.active && styles[`container-closed`]} `}
                    /*onMouseEnter={() => clearTimeout(timeoutRef.current)}*/
                >
                    <div className={styles.content}>
                        <div className={styles[`info`]}>
                            <div className={styles.header}>
                                <div className={styles[`header-title`]}>
                                    <img
                                        className={styles[`help-icon`]}
                                        src={helpIcon}
                                    />
                                    <div className={styles.title}>{title}</div>
                                </div>
                                <img
                                    src={exitIcon}
                                    className={styles[`exit-icon`]}
                                    onClick={() => {
                                        onClose();
                                    }}
                                />
                            </div>
                            <div className={styles.description}>
                                <div
                                    style={{ display: "inline" }}
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                                {inHelp.moreQuestions && (
                                    <div
                                        className={styles[`ovdje-button`]}
                                        onClick={() =>
                                            setInHelp({
                                                title: "Dodatna pomoć",
                                                description: `Ako niste sigurni što odabrati od ponuđenih usluga, odaberite sljedeće opcije koje opisuju vaše potrebe usluge. Na temelju vaših odgovora, mi ćemo vam ponuditi potrebnu pomoć i pogodnu uslugu. Nakon odabranih željenih pitanja kliknite na gumb "Potvrdi"`,
                                                active: true,
                                                questions: JSON.parse(
                                                    JSON.stringify(
                                                        selectedAttributes
                                                    )
                                                ),
                                            })
                                        }
                                    >
                                        ovdje.
                                    </div>
                                )}
                            </div>
                        </div>
                        {inHelp &&
                            inHelp.questions &&
                            inHelp.questions.length > 0 && (
                                <div className={styles[`action-container`]}>
                                    <TypeFilter
                                        serviceTypes={serviceTypes}
                                        setServiceTypes={setServiceTypes}
                                        setInHelp={setInHelp}
                                        alwaysMobileLayout={true}
                                    />
                                    <div
                                        className={
                                            styles[`questions-container`]
                                        }
                                    >
                                        <div
                                            className={styles[`questions-list`]}
                                        >
                                            {inHelp.questions.map((option) => {
                                                return (
                                                    <div
                                                        className={
                                                            styles.question
                                                        }
                                                        key={option.id}
                                                    >
                                                        <ToggleButton
                                                            value={option.id}
                                                            key={option.id}
                                                            active={
                                                                option.active
                                                            }
                                                            onClick={
                                                                toggleSelectedAttribute
                                                            }
                                                            animated={true}
                                                            style={{
                                                                animationDelay: `${
                                                                    option.id *
                                                                        100 +
                                                                    150
                                                                }ms`,
                                                            }}
                                                        >
                                                            {option.name}
                                                        </ToggleButton>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            </>
        );
    }
);

export default Help;
